import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useMemo } from '@wordpress/element';
/**
 * Internal dependencies
 */

import InserterPreviewPanel from '../inserter/preview-panel';
import { replaceActiveStyle } from './utils';
export default function BlockStylesPreviewPanel(_ref) {
  let {
    genericPreviewBlock,
    style,
    className,
    activeStyle
  } = _ref;
  const styleClassName = replaceActiveStyle(className, activeStyle, style);
  const previewBlocks = useMemo(() => {
    return { ...genericPreviewBlock,
      title: style.label || style.name,
      description: style.description,
      initialAttributes: { ...genericPreviewBlock.attributes,
        className: styleClassName + ' block-editor-block-styles__block-preview-container'
      }
    };
  }, [genericPreviewBlock, styleClassName]);
  return createElement(InserterPreviewPanel, {
    item: previewBlocks,
    isStylePreview: true
  });
}
//# sourceMappingURL=preview-panel.js.map